export const BROKER_INVITE_MODAL_OPEN = "BROKER_INVITE_MODAL_OPEN";
export const BROKER_INVITE_MODAL_CLOSE = "BROKER_INVITE_MODAL_CLOSE";

export const closeBrokerInviteModal = () => (dispatch) =>
  dispatch({
    type: BROKER_INVITE_MODAL_CLOSE,
  });

export const openBrokerInviteModal = () => (dispatch) =>
  dispatch({
    type: BROKER_INVITE_MODAL_OPEN,
  });
